import React from 'react';
import { MyProfile } from '../../components/my-profile';
import { ContentSection, Heading } from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';

export const MyProfilePage: React.FC = () => {
    const { t } = useTranslation('my-profile');
    const title = t('headline');

    return (
        <ContentSection pageWrapSize="medium">
            <Heading level={1}>{title}</Heading>
            <MyProfile />
        </ContentSection>
    );
};
